export default {
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || null,
  gisUrl: process.env.REACT_APP_GIS_URL || null,
}
